import _ from 'lodash';

export const objectKeysToCamelCase = <T = unknown>(anyCaseObject): T => {
    if (!_.isObject(anyCaseObject)) {
        return anyCaseObject;
    } else if (_.isArray(anyCaseObject)) {
        return anyCaseObject.map((property) => objectKeysToCamelCase(property)) as any;
    }
    return _.reduce(anyCaseObject, (camelCaseObj, value, key) => {
        return {
            ...camelCaseObj,
            [_.camelCase(key)]: objectKeysToCamelCase(value)
        } as any;
    }, {});
};

export const removeKeyFromObject = <T extends Object>(object: T, key: keyof T | (keyof T)[]) => {
    const newObject: T = { ...object };
    const keysToRemove = key instanceof Array ? key : [key];
    keysToRemove.forEach(removeKye => {
        delete newObject[removeKye];
    });
    return newObject;
};

type AnyObject = { [key: string]: any };

export const removeKeysDeep = <T extends AnyObject>(obj: T, paths: string[]): T => {
    const clone = (input: any): any => {
        if (Array.isArray(input)) return input.map(clone);
        if (input && typeof input === 'object') {
            return Object.entries(input).reduce((acc, [key, value]) => {
                acc[key] = clone(value);
                return acc;
            }, {} as AnyObject);
        }
        return input;
    };

    const result = clone(obj);

    for (const path of paths) {
        const keys = path.split('.');
        let current: any = result;

        for (let i = 0; i < keys.length - 1; i++) {
            if (!(keys[i] in current)) {
                // tslint:disable-next-line:no-null-keyword
                current = null;
                break;
            }
            current = current[keys[i]];
        }

        if (current && typeof current === 'object') {
            delete current[keys[keys.length - 1]];
        }
    }

    return result;
};